export default __webpack_public_path__ + "static/footer-background-5bfe08fa78987af66764b0ae03bd2db7.png";